import { createContext, FC, ReactElement, useReducer } from 'react';
import { StoreContextType } from 'types/reducers';
import storeReducer, { defaultState } from './reducers';

interface Props {
    children: ReactElement<any | any>;
}

export const StoreContext = createContext<StoreContextType>({
    state: defaultState,
    dispatch: () => {},
});

const StoreContextComponent: FC<Props> = (props) => {
    const [state, dispatch] = useReducer(storeReducer, defaultState);

    return <StoreContext.Provider value={{ state, dispatch }}>{props.children}</StoreContext.Provider>;
};

export default StoreContextComponent;
